import { CartActions } from 'modules/shop/cart/types';
import { useNotificationManager } from './hooks';
import { NotificationPayload } from './types';

export const showNotificationAddedToCart = (payload: NotificationPayload) => {
  useNotificationManager
    .getState()
    .pushNotification({ name: CartActions.ADD, payload });
};

export const showNotificationLimited = (payload: NotificationPayload) => {
  useNotificationManager
    .getState()
    .pushNotification({ name: CartActions.LIMITED, payload });
};

export const showNotificationPreRemove = (payload: NotificationPayload) => {
  useNotificationManager
    .getState()
    .pushNotification({ name: CartActions.DELETE, payload });
};

export const showNotificationRemove = () => {
  useNotificationManager.getState().pushNotification({
    name: CartActions.DELETE_SUCCESS,
    payload: {},
  });
};

export const showNotificationSizeNotSelected = () => {
  useNotificationManager.getState().pushNotification({
    name: CartActions.SIZE_NOT_SELECTED,
    payload: {},
  });
};
